import { inject, Injectable } from "@angular/core";

import { IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";
import { QuerySourceService } from "@main/reporting.v3/api/query-source.service";
import { QueryData, QueryResolver } from "@main/reporting.v3/core/query-hub/models";
import { IDashboardQueryMinimal } from "@main/reporting.v3/dashboard/dashboard-models";
import { DashboardQueryService } from "@main/reporting.v3/dashboard/api/dashboard-query.service";
import { IQueryPageRequest, IQuerySourcePreload } from "@main/reporting.v3/core/reporting-models";


@Injectable()
export class DashboardQueryResolverService implements QueryResolver {

    private dashboardQueryService: DashboardQueryService = inject(DashboardQueryService);
    private querySourceService: QuerySourceService = inject(QuerySourceService);

    // TODO: Temporary approach until we implement a dashboard store.
    public dashboardId: string;

    public async getQueryId(queryName: string): Promise<string> {
        if (!queryName?.length || !this.dashboardId) return null;

        // Try to resolve a query with this name among dashboard queries.
        const minimal: IDashboardQueryMinimal = await this.dashboardQueryService.getQueryByName(this.dashboardId, queryName);

        if (!!minimal?.querySourceId) return minimal.querySourceId;

        const settings: IHttpResponseHandlerSettings = { showErrorMessage: false };

        // If there is no dashboard query with that name, try to resolve it globally.
        const preload: IQuerySourcePreload = await this.querySourceService.getQuerySourcePreload(queryName, settings);

        return preload?.id;
    }

    public async getQuery(querySourceId: string, request: IQueryPageRequest): Promise<QueryData> {
        if (!querySourceId || !request) return null;

        const settings: IHttpResponseHandlerSettings = { showErrorMessage: false };

        return this.querySourceService.getQueryData(querySourceId, request, settings);
    }
}